import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setGlobalNavigate } from '@/lib/global-navigate';

export function useRegisterGlobalNavigate() {
    const navigate = useNavigate();

    useEffect(() => {
        setGlobalNavigate(navigate);
        return () => setGlobalNavigate(null);
    }, [navigate]);
}
